import { unsafeCSS as w, LitElement as y, html as Q } from "lit";
import { queryAll as W, queryAssignedElements as k, property as r, query as Z } from "lit/decorators.js";
import { registerComponent as A } from "@aileron/icon";
import { registerComponent as j } from "@aileron/tag";
import { unsafeStatic as O, html as u } from "lit/static-html.js";
import { ifDefined as S } from "lit/directives/if-defined.js";
import { classMap as tt } from "lit/directives/class-map.js";
const et = (a) => {
  class t extends a {
    constructor(...n) {
      super(...n), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const i = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(i.getElementsByTagName("link")).findIndex(
        (b) => b.href === this.fontLink
      ) === -1) {
        const b = document.createElement("link");
        b.href = this.fontLink, b.rel = "stylesheet", document.head.appendChild(b);
      }
    }
  }
  return t;
}, it = `*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,[type=button],[type=reset],[type=submit]{-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.pointer-events-none{pointer-events:none}.static{position:static}.absolute{position:absolute}.relative{position:relative}.left-0{left:0}.left-\\[initial\\]{left:initial}.left-full{left:100%}.right-0{right:0}.right-full{right:100%}.top-0{top:0}.block{display:block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.hidden{display:none}.h-12{height:3rem}.h-6{height:1.5rem}.w-5{width:1.25rem}.flex-row-reverse{flex-direction:row-reverse}.items-center{align-items:center}.justify-between{justify-content:space-between}.rounded{border-radius:.25rem}.bg-blue-060{background-color:#0860c4}.bg-green-060{background-color:#316833}.bg-neutral-060{background-color:#50657c}.bg-neutral-120{background-color:#f3f5f7}.bg-orange-060{background-color:#ae3f13}.bg-red-060{background-color:#cd1d32}.px-1{padding-left:.25rem;padding-right:.25rem}.py-0{padding-top:0;padding-bottom:0}.py-0\\.5{padding-top:.125rem;padding-bottom:.125rem}.pl-0{padding-left:0}.pl-4{padding-left:1rem}.pr-2{padding-right:.5rem}.pr-4{padding-right:1rem}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-base{font-size:1rem}.text-sm{font-size:.875rem}.text-xl{font-size:1.5rem}.text-xs{font-size:.75rem}.uppercase{text-transform:uppercase}.leading-4{line-height:1rem}.leading-5{line-height:1.25rem}.leading-6{line-height:1.5rem}.text-blue-060{color:#0860c4}.text-neutral-000{color:#101419}.text-neutral-140{color:#fff}.text-red-070{color:#e33b4e}.font-medium{font-weight:500;font-variation-settings:"wght" 500}.font-normal{font-weight:400;font-variation-settings:"wght" 400}[hidden]{display:none!important}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-\\[initial\\]:after{content:var(--tw-content);left:initial}.after\\:left-full:after{content:var(--tw-content);left:100%}.after\\:right-full:after{content:var(--tw-content);right:100%}.after\\:top-0:after{content:var(--tw-content);top:0}.after\\:block:after{content:var(--tw-content);display:block}.after\\:h-6:after{content:var(--tw-content);height:1.5rem}.after\\:w-5:after{content:var(--tw-content);width:1.25rem}.after\\:bg-blue-060:after{content:var(--tw-content);background-color:#0860c4}.after\\:bg-green-060:after{content:var(--tw-content);background-color:#316833}.after\\:bg-neutral-060:after{content:var(--tw-content);background-color:#50657c}.after\\:bg-neutral-120:after{content:var(--tw-content);background-color:#f3f5f7}.after\\:bg-orange-060:after{content:var(--tw-content);background-color:#ae3f13}.after\\:bg-red-060:after{content:var(--tw-content);background-color:#cd1d32}
`, nt = w(it), x = "aileron-color-scheme", F = "aileron-color-scheme-change", E = (a) => {
  class t extends a {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (n) => {
        n.detail ? this.setAttribute(x, n.detail) : this.removeAttribute(x);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        F,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const n = document.documentElement.getAttribute(
        x
      );
      n && this.setAttribute(x, n);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        F,
        this.handleSchemeSwitch
      );
    }
  }
  return t.styles = [
    nt,
    a.styles ?? []
  ], t;
}, D = E(et(y)), _ = `:host(.adc-nav-bar){display:flex;flex-direction:column}:host(.adc-nav-bar) ::slotted(.adc-nav-item){border-bottom:1px solid #e6eaef!important}:host(.adc-nav-bar) ::slotted(.adc-nav-item:last-child){border-bottom:none!important}:host(.adc-nav-item){display:flex;flex-direction:column;border:1px solid transparent}:host(.adc-nav-item) .adc-nav-bar__icon{display:flex;fill:currentcolor;margin-top:0;margin-bottom:0;margin-right:1rem;margin-left:0;transition:transform .37s cubic-bezier(.4,0,.2,1) 0ms;transform:rotateX(0);transform-origin:center}:host(.adc-nav-item.focus-visible){border-radius:.25rem;outline-offset:-2px;outline:2px solid;outline-color:#0a78f5}:host(.adc-nav-item) .adc-nav-bar__heading{justify-content:space-between}:host(.adc-nav-item:not([disabled])) button.adc-nav-bar__heading{cursor:pointer}:host(.adc-nav-item:not([disabled])) .adc-nav-bar__title{display:flex;align-items:center}:host(.adc-nav-item:not([disabled])) .adc-nav-bar_label{padding-left:8px}:host(.adc-nav-item:not([disabled],[toggle-off])) .adc-nav-bar__title:hover{text-decoration:underline}:host(.adc-nav-item[disabled]) .adc-nav-bar__heading{color:#b4c1cf}:host(.adc-nav-item[open]) .adc-nav-bar__icon{transform:rotateX(180deg)}.chevron-down{color:#0860c4}:host(.adc-nav-item:not([toggle-off])) .adc-nav-bar__content--wrapper{background-color:#fff;max-height:0;overflow:hidden;transition:max-height .24s cubic-bezier(0,0,.2,1) .1s}:host(.adc-nav-item[open]) .adc-nav-bar__content--wrapper{max-height:200vh;transition:max-height .24s cubic-bezier(.4,0,1,1) .1s}.adc-nav-bar__title .fullCircle .adc-icon,.fullCircle .adc-icon{color:#e33b4e}.adc-nav-bar__title .adc-icon{color:#0860c4}.adc-nav-bar__heading{background-color:#fff;padding-top:1rem;padding-bottom:1rem;padding-left:0;padding-right:0;color:#181e25;align-items:center;display:flex;appearance:none;height:58px;border:none}.adc-nav-bar__heading:focus{outline:0}.adc-nav-bar__content{color:#101419}:host(.adc-nav-bar) ::slotted(.adc-nav-link){border-bottom:1px solid #e6eaef!important}:host(.adc-nav-bar) ::slotted(.adc-nav-link:last-child){border-bottom:none!important}:host(.adc-nav-link){display:flex;flex-direction:column;border:1px solid transparent}:host(.adc-nav-link) .adc-nav-bar__icon{display:flex;fill:currentcolor;margin-top:0;margin-bottom:0;margin-left:1rem;margin-right:1rem;transition:transform .37s cubic-bezier(.4,0,.2,1) 0ms;transform:rotateX(0);transform-origin:center}:host(.adc-nav-link.focus-visible),:host(.adc-link-item) .link-item:focus-within,:host(.adc-link-item) .link-item:focus-visible,:host(.adc-nav-link) .adc-nav-bar__heading:not([disabled]):focus-within{border-radius:.25rem;outline-offset:-2px;outline:2px solid;outline-color:#0a78f5}:host(.adc-nav-link[label-position="left"]) .adc-nav-bar__heading{justify-content:space-between}:host(.adc-nav-link:not([disabled])) .adc-nav-bar__heading{cursor:pointer}:host(.adc-nav-link:not([disabled])) .adc-nav-bar__title{display:flex;align-items:center}:host(.adc-nav-link:not([disabled])) .adc-nav-bar_label{padding-left:8px}:host(.adc-nav-link:not([disabled])) .adc-nav-bar__heading:hover{text-decoration:underline}:host(.adc-nav-link[disabled]) .adc-nav-bar__heading{color:#b4c1cf}:host(.adc-link-item) ::slotted(a:focus-visible),:host(.adc-nav-link) ::slotted(a:focus-visible){outline:none}:host(.adc-link-item) .link-item{padding:0 .5rem 0 2rem;text-decoration:none}:host(.adc-link-item) .badges,:host(.adc-nav-item) .badges{display:flex;align-items:center;gap:.5rem;color:red}:host(.adc-link-item) .badges>*{display:flex}:host(.adc-nav-item) .badges>*{display:flex}:host(.adc-link-item) .link-item.selected:hover{text-decoration:underline;cursor:pointer}:host(.adc-link-item) .link-item:hover{cursor:pointer}:host(.adc-link-item),:host(.adc-nav-link),:host(.adc-nav-item[highlight]) .adc-nav-bar__heading{color:#181e25}:host(.adc-link-item) .link-item:hover,:host(.adc-nav-link) .adc-nav-bar__heading:not([disabled]):hover,:host(.adc-nav-item[highlight]) .adc-nav-bar__heading:not([disabled]){border-radius:.25rem;background-color:#f9fafb}:host(.adc-nav-item[highlight]) .adc-nav-bar__heading{background-color:#f5faff}:host(.adc-link-item) .selected,:host(.adc-link-item) .link-item.selected:hover{color:#0860c4;background-color:#f5faff;border-radius:.25rem;font-weight:700;font-variation-settings:"wght" 700}:host(.adc-link-item) .link-item:active,:host(.adc-nav-link) .adc-nav-bar__heading:not([disabled]):active{background-color:#f3f5f7}:host(.adc-link-item) .fullCircle,:host(.adc-nav-item) .fullCircle{display:inline-block;position:absolute;margin-top:-3px}:host(.adc-nav-item) .fullCircle{right:45px}:host(.adc-link-item) .link-item-badge{display:inline-block;margin-right:7px}:host(.adc-nav-item) ul{list-style:none;margin:0;padding:0}.hidden-accessible{border:0 none;clip:rect(0,0,0,0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px}
`;
var at = Object.defineProperty, ot = Object.getOwnPropertyDescriptor, T = (a, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? ot(t, e) : t, s = a.length - 1, l; s >= 0; s--)
    (l = a[s]) && (i = (n ? l(t, e, i) : l(i)) || i);
  return n && i && at(t, e, i), i;
};
function M(a) {
  return `numerical:${[
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine"
  ][a]}`;
}
class p extends D {
  constructor() {
    super(...arguments), this.a11yLabel = "", this.ariaOrientation = "";
  }
  render() {
    return Q`<slot></slot>`;
  }
  connectedCallback() {
    this.classList.add("adc-nav-bar"), this.hasAttribute("role") || this.setAttribute("role", "navigation"), this.hasAttribute("a11y-orientation") || this.setAttribute("a11y-orientation", "vertical"), this.hasAttribute("aria-label") || this.setAttribute("aria-label", this.a11yLabel), super.connectedCallback(), this.addEventListener("adc-link-item-click", this._handleSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("adc-link-item-click", this._handleSelect);
  }
  _handleSelect() {
    this._listItems.map((e) => e.linkItems).forEach((e) => {
      e.forEach((n) => {
        n.clearSelected();
      });
    });
  }
}
p.styles = [D.styles || [], w(_)];
T([
  W(".adc-nav-item")
], p.prototype, "textNode", 2);
T([
  k({ selector: ".adc-nav-item" })
], p.prototype, "_listItems", 2);
T([
  r({ attribute: "a11y-label" })
], p.prototype, "a11yLabel", 2);
T([
  r({ attribute: "a11y-orientation" })
], p.prototype, "ariaOrientation", 2);
try {
  customElements.define("adc-nav-bar", p);
} catch {
}
function rt(a) {
  try {
    customElements.define(`${a}-nav-bar`, class extends p {
    });
  } catch {
  }
}
function st(a, t, e) {
  const n = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...e
  });
  return a.dispatchEvent(n), n;
}
var lt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
(function(a, t) {
  (function(e, n) {
    n();
  })(lt, function() {
    function e(i) {
      var s = !0, l = !1, b = null, V = {
        text: !0,
        search: !0,
        url: !0,
        tel: !0,
        email: !0,
        password: !0,
        number: !0,
        date: !0,
        month: !0,
        week: !0,
        time: !0,
        datetime: !0,
        "datetime-local": !0
      };
      function $(o) {
        return !!(o && o !== document && o.nodeName !== "HTML" && o.nodeName !== "BODY" && "classList" in o && "contains" in o.classList);
      }
      function U(o) {
        var J = o.type, B = o.tagName;
        return !!(B === "INPUT" && V[J] && !o.readOnly || B === "TEXTAREA" && !o.readOnly || o.isContentEditable);
      }
      function z(o) {
        o.classList.contains("focus-visible") || (o.classList.add("focus-visible"), o.setAttribute("data-focus-visible-added", ""));
      }
      function R(o) {
        o.hasAttribute("data-focus-visible-added") && (o.classList.remove("focus-visible"), o.removeAttribute("data-focus-visible-added"));
      }
      function H(o) {
        o.metaKey || o.altKey || o.ctrlKey || ($(i.activeElement) && z(i.activeElement), s = !0);
      }
      function L(o) {
        s = !1;
      }
      function q(o) {
        $(o.target) && (s || U(o.target)) && z(o.target);
      }
      function X(o) {
        $(o.target) && (o.target.classList.contains("focus-visible") || o.target.hasAttribute("data-focus-visible-added")) && (l = !0, window.clearTimeout(b), b = window.setTimeout(function() {
          l = !1;
        }, 100), R(o.target));
      }
      function G(o) {
        document.visibilityState === "hidden" && (l && (s = !0), P());
      }
      function P() {
        document.addEventListener("mousemove", d), document.addEventListener("mousedown", d), document.addEventListener("mouseup", d), document.addEventListener("pointermove", d), document.addEventListener("pointerdown", d), document.addEventListener("pointerup", d), document.addEventListener("touchmove", d), document.addEventListener("touchstart", d), document.addEventListener("touchend", d);
      }
      function Y() {
        document.removeEventListener("mousemove", d), document.removeEventListener("mousedown", d), document.removeEventListener("mouseup", d), document.removeEventListener("pointermove", d), document.removeEventListener("pointerdown", d), document.removeEventListener("pointerup", d), document.removeEventListener("touchmove", d), document.removeEventListener("touchstart", d), document.removeEventListener("touchend", d);
      }
      function d(o) {
        o.target.nodeName && o.target.nodeName.toLowerCase() === "html" || (s = !1, Y());
      }
      document.addEventListener("keydown", H, !0), document.addEventListener("mousedown", L, !0), document.addEventListener("pointerdown", L, !0), document.addEventListener("touchstart", L, !0), document.addEventListener("visibilitychange", G, !0), P(), i.addEventListener("focus", q, !0), i.addEventListener("blur", X, !0), i.nodeType === Node.DOCUMENT_FRAGMENT_NODE && i.host ? i.host.setAttribute("data-js-focus-visible", "") : i.nodeType === Node.DOCUMENT_NODE && (document.documentElement.classList.add("js-focus-visible"), document.documentElement.setAttribute("data-js-focus-visible", ""));
    }
    if (typeof window < "u" && typeof document < "u") {
      window.applyFocusVisiblePolyfill = e;
      var n;
      try {
        n = new CustomEvent("focus-visible-polyfill-ready");
      } catch {
        n = document.createEvent("CustomEvent"), n.initCustomEvent("focus-visible-polyfill-ready", !1, !1, {});
      }
      window.dispatchEvent(n);
    }
    typeof document < "u" && e(document);
  });
})();
try {
  document.body.querySelector(":focus-visible");
} catch {
}
const dt = (a) => {
  class t extends a {
    constructor(...n) {
      super(...n);
    }
  }
  return t;
};
var ct = Object.defineProperty, ut = Object.getOwnPropertyDescriptor, I = (a, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? ut(t, e) : t, s = a.length - 1, l; s >= 0; s--)
    (l = a[s]) && (i = (n ? l(t, e, i) : l(i)) || i);
  return n && i && ct(t, e, i), i;
};
class v extends dt(y) {
  constructor() {
    super(), this.disabled = !1, this.autofocus = !1, this._tabIndex = 0, this.manipulatingTabindex = !1;
  }
  get tabIndex() {
    if (this.focusElement === this) {
      const e = this.hasAttribute("tabindex") ? parseFloat(this.getAttribute("tabindex")) : NaN;
      return isNaN(e) ? -1 : e;
    }
    const t = parseFloat(
      this.hasAttribute("tabindex") && this.getAttribute("tabindex") || "0"
    );
    return this.disabled || t < 0 ? -1 : this.focusElement ? this.focusElement.tabIndex : t;
  }
  set tabIndex(t) {
    if (this.manipulatingTabindex) {
      this.manipulatingTabindex = !1;
      return;
    }
    if (this.focusElement === this) {
      if (t !== this.tabIndex) {
        this._tabIndex = t;
        const e = this.disabled ? "-1" : `${t}`;
        this.setAttribute("tabindex", e);
      }
      return;
    }
    if (t === -1 ? this.addEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    ) : (this.manipulatingTabindex = !0, this.removeEventListener(
      "pointerdown",
      this.onPointerdownManagementOfTabIndex
    )), t === -1 || this.disabled) {
      this.setAttribute("tabindex", "-1"), this.removeAttribute("focusable"), t !== -1 && this.manageFocusElementTabindex(t);
      return;
    }
    this.setAttribute("focusable", ""), this.hasAttribute("tabindex") ? this.removeAttribute("tabindex") : this.manipulatingTabindex = !1, this.manageFocusElementTabindex(t);
  }
  onPointerdownManagementOfTabIndex() {
    this.tabIndex === -1 && (this.tabIndex = 0, this.focus({ preventScroll: !0 }));
  }
  async manageFocusElementTabindex(t) {
    this.focusElement || await this.updateComplete, t === null ? this.focusElement.removeAttribute("tabindex") : this.focusElement.tabIndex = t;
  }
  get focusElement() {
    return this;
  }
  focus(t) {
    this.disabled || !this.focusElement || (this.focusElement !== this ? this.focusElement.focus(t) : HTMLElement.prototype.focus.apply(this, [t]));
  }
  blur() {
    const t = this.focusElement || this;
    t !== this ? t.blur() : HTMLElement.prototype.blur.apply(this);
  }
  click() {
    if (this.disabled)
      return;
    const t = this.focusElement || this;
    t !== this ? t.click() : HTMLElement.prototype.click.apply(this);
  }
  manageAutoFocus() {
    this.autofocus && (this.dispatchEvent(new KeyboardEvent("keydown", { code: "Tab" })), this.focusElement.focus());
  }
  firstUpdated(t) {
    super.firstUpdated(t), this.manageAutoFocus(), (!this.hasAttribute("tabindex") || this.getAttribute("tabindex") !== "-1") && this.setAttribute("focusable", "");
  }
  update(t) {
    t.has("disabled") && this.handleDisabledChanged(
      this.disabled,
      t.get("disabled")
    ), super.update(t);
  }
  updated(t) {
    super.updated(t), t.has("disabled") && this.disabled && this.blur();
  }
  async handleDisabledChanged(t, e) {
    const n = () => this.focusElement !== this && typeof this.focusElement.disabled < "u";
    t ? (this.manipulatingTabindex = !0, this.setAttribute("tabindex", "-1"), await this.updateComplete, n() ? this.focusElement.disabled = !0 : this.setAttribute("aria-disabled", "true")) : e && (this.manipulatingTabindex = !0, this.focusElement === this ? this.setAttribute("tabindex", `${this._tabIndex}`) : this.removeAttribute("tabindex"), await this.updateComplete, n() ? this.focusElement.disabled = !1 : this.removeAttribute("aria-disabled"));
  }
}
I([
  r({ type: Boolean, reflect: !0 })
], v.prototype, "disabled", 2);
I([
  r({ type: Boolean })
], v.prototype, "autofocus", 2);
I([
  r({ type: Number })
], v.prototype, "tabIndex", 1);
var ht = Object.defineProperty, mt = Object.getOwnPropertyDescriptor, f = (a, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? mt(t, e) : t, s = a.length - 1, l; s >= 0; s--)
    (l = a[s]) && (i = (n ? l(t, e, i) : l(i)) || i);
  return n && i && ht(t, e, i), i;
};
const ft = E(y), m = class N extends v {
  constructor(t) {
    super(), this.enableSlotClickPropagation = !1, this.route = !1, this.selected = !1, this.badgeCount = 0, this.a11yTagText = "", this.a11yRole = null, this.a11yBadgeCountText = "", this.tagName = "", this.handleSlotClick = (e) => {
      this.enableSlotClickPropagation || e.stopPropagation();
    }, this._handleKeydown = ({ key: e }) => {
      e === "Enter" && this._handleSelection();
    }, this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-link-item"), A(
      this.customElementString ? this.customElementString + "-link-item" : "adc-link-item"
    ), j(
      this.customElementString ? this.customElementString + "-link-item" : "adc-link-item"
    );
  }
  clearSelected() {
    this.textNode.classList.remove("selected");
  }
  _handleSelection() {
    this.unnamedSlotEls[0].nodeName === "A" && this.unnamedSlotEls[0].click(), st(this, "adc-link-item-click", {
      detail: { value: `adc-link-item-${N.instanceCount++}` }
    }), this.textNode.classList.add("selected");
  }
  /**
   * Whenever the link is first rendered we set a unique id
   * @param changes
   */
  firstUpdated(t) {
    super.firstUpdated(t), this.hasAttribute("id") || (this.id = `adc-link-item-${N.instanceCount++}`), this.unnamedSlotEls[0].nodeName === "A" && (this.unnamedSlotEls[0].setAttribute("tabindex", "-1"), this.unnamedSlotEls[0].addEventListener("click", this.handleSlotClick));
  }
  disconnectedCallback() {
    this.unnamedSlotEls[0].nodeName === "A" && this.unnamedSlotEls[0].removeEventListener("click", this.handleSlotClick);
  }
  createTagName(t) {
    return O(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    return u` <li>
      <div
        tabindex="0"
        role="${S(this.a11yRole)}"
        aria-current=${this.selected}
        aria-selected=${this.selected}
        class="link-item font-sans font-normal text-sm leading-6 h-12 flex items-center justify-between ${this.selected ? "selected" : ""}"
        @click=${this._handleSelection}
        @keydown=${this._handleKeydown}
        part="link-item"
      >
        <slot></slot>
        <div class="badges">
          ${this.tagName ? u`<${this.createTagName("-link-item-tag")}
                  label-text="${this.tagName}"
                  aria-hidden="true"
                  position="rtl"
                  kind="success"
                  variant=""
                ></${this.createTagName("-link-item-tag")}>
                <span class="hidden-accessible">,${this.a11yTagText}</span>` : u`<span aria-hidden="true"></span> `}
          ${this.badgeCount && this.badgeCount > 0 ? u`<${this.createTagName("-link-item-icon")}
                  class="text-red-070"
                  icon="${M(this.badgeCount)}"
                  size="24"
                  filled
                ></${this.createTagName("-link-item-icon")}>
                <span class="hidden-accessible"
                  >,${this.a11yBadgeCountText}</span
                >` : u`<span aria-hidden="true"></span>`}
        </div>
      </div>
    </li>`;
  }
};
m.styles = [ft.styles || [], w(_)];
m.instanceCount = 0;
f([
  Z(".link-item")
], m.prototype, "textNode", 2);
f([
  k()
], m.prototype, "unnamedSlotEls", 2);
f([
  r({ type: Boolean, reflect: !0, attribute: "enable-slot-click-propagation" })
], m.prototype, "enableSlotClickPropagation", 2);
f([
  r({ type: Boolean, reflect: !0 })
], m.prototype, "route", 2);
f([
  r({ type: Boolean, reflect: !0 })
], m.prototype, "selected", 2);
f([
  r({ type: Number, reflect: !0, attribute: "badge-count" })
], m.prototype, "badgeCount", 2);
f([
  r({ type: String, reflect: !0, attribute: "a11y-tag-text" })
], m.prototype, "a11yTagText", 2);
f([
  r({ type: String, reflect: !0, attribute: "a11y-role" })
], m.prototype, "a11yRole", 2);
f([
  r({ type: String, reflect: !0, attribute: "a11y-badge-count-text" })
], m.prototype, "a11yBadgeCountText", 2);
f([
  r({ type: String, reflect: !0, attribute: "tag-name" })
], m.prototype, "tagName", 2);
let K = m;
try {
  customElements.define("adc-link-item", K);
} catch {
}
function bt(a) {
  try {
    customElements.define(
      `${a}-link-item`,
      class extends K {
        constructor() {
          super(a);
        }
      }
    );
  } catch {
  }
}
var pt = Object.defineProperty, gt = Object.getOwnPropertyDescriptor, h = (a, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? gt(t, e) : t, s = a.length - 1, l; s >= 0; s--)
    (l = a[s]) && (i = (n ? l(t, e, i) : l(i)) || i);
  return n && i && pt(t, e, i), i;
};
const vt = E(y);
class c extends v {
  constructor(t) {
    super(), this._handleKeydownExpando = ({ key: e }) => {
      this.toggleOff || this.open && (e === "Esc" || e === "Escape") && this._handleUserInitiatedToggle(!1);
    }, this.disabled = !1, this.highlight = !1, this.open = !1, this.toggleOff = !1, this.closeOnItemSelected = !1, this.tagName = "", this.a11yTagText = "", this.labelText = "", this.a11yLabel = "", this.icon = "", this.iconOutlined = !1, this.badgeCount = 0, this.a11yBadgeCountText = "", this.customElementString = t;
  }
  get linkItems() {
    return this._listItems;
  }
  _handleUserInitiatedToggle(t = !this.open) {
    const e = {
      bubbles: !0,
      cancelable: !0,
      composed: !0,
      detail: {
        open: t
      }
    };
    this.dispatchEvent(
      new CustomEvent(
        this.constructor.eventBeforeToggle,
        e
      )
    ) && (this.disabled || (this.open = t, this.dispatchEvent(
      new CustomEvent(
        this.constructor.eventToggle,
        e
      )
    )));
  }
  _handleLinkItemSelect() {
    this._handleUserInitiatedToggle(!this.closeOnItemSelected);
  }
  _handleClickExpando() {
    this.toggleOff || this._handleUserInitiatedToggle();
  }
  connectedCallback() {
    this.classList.add("adc-nav-item"), A(
      this.customElementString ? this.customElementString + "-nav-item" : "adc-nav-item"
    ), j(
      this.customElementString ? this.customElementString + "-nav-item" : "adc-nav-item"
    ), this.hasAttribute("role") || this.setAttribute("role", "listitem"), super.connectedCallback(), this.addEventListener("adc-link-item-click", this._handleLinkItemSelect);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.removeEventListener("adc-link-item-click", this._handleLinkItemSelect);
  }
  renderBadges() {
    return u`<div class="badges">
      ${this.tagName ? u`<${this.createTagName("-nav-item-tag")}
              label-text="${this.tagName}"
              aria-hidden="true"
              position="rtl"
              kind="success"
              variant=""
            ></${this.createTagName("-nav-item-tag")}>
            <span class="hidden-accessible">,${this.a11yTagText}</span>` : u`<span aria-hidden="true"></span> `}
      ${this.badgeCount && this.badgeCount > 0 && !this.open ? u`<${this.createTagName("-nav-item-icon")}
              class="text-red-070"
              icon="${M(this.badgeCount)}"
              size="24"
              filled
            ></${this.createTagName("-nav-item-icon")}>
            <span class="hidden-accessible">,${this.a11yBadgeCountText}</span>` : u`<span aria-hidden="true"></span>`}
    </div>`;
  }
  renderNavArrow() {
    return u` <${this.createTagName("-nav-item-icon")}
      icon="navigation:chevron-down"
      part="expando-icon"
      size="24"
      class="adc-nav-bar__icon chevron-down"
    >
    </${this.createTagName("-nav-item-icon")}>`;
  }
  renderTitle() {
    const { a11yLabel: t, labelText: e, icon: n, iconOutlined: i } = this;
    return u`<span part="title" class="adc-nav-bar__title">
      <${this.createTagName("-nav-item-icon")}
        aria-hidden="true"
        size="24"
        icon=${n}
        ?outlined=${i}
      ></${this.createTagName("-nav-item-icon")}>
      <span
        aria-label="${t}"
        class="adc-nav-bar_label font-sans font-medium text-base leading-6"
      >
        ${e}
      </span>
    </span>`;
  }
  renderContent() {
    return u`<div
      id="content"
      part="content"
      class="adc-nav-bar__content--wrapper"
      ?hidden=${this.toggleOff ? !1 : !this.open}
    >
      <div
        class="adc-nav-bar__content font-sans font-normal text-base leading-6"
      >
        <ul>
          <slot></slot>
        </ul>
      </div>
    </div>`;
  }
  createTagName(t) {
    return O(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    const {
      disabled: t,
      highlight: e,
      open: n,
      toggleOff: i,
      _handleClickExpando: s,
      _handleKeydownExpando: l
    } = this;
    return i ? u`<h3
            ?highlight="${e}"
            class="adc-nav-bar__heading font-sans font-normal text-base leading-6"
          >
            ${this.renderTitle()}
          </h3>
          ${this.renderContent()}` : u`<button
            ?disabled="${t}"
            ?highlight="${e}"
            ?toggle-off="${i}"
            type="button"
            part="expando"
            class="adc-nav-bar__heading font-sans font-normal text-base leading-6"
            aria-controls="${S(
      this.toggleOff ? void 0 : "content"
    )}"
            aria-expanded=${S(this.toggleOff ? void 0 : n)}
            @click="${s}"
            @keydown="${l}"
          >
            ${this.renderTitle()}
            <div class="flex">
              ${this.renderBadges()} ${this.renderNavArrow()}
            </div>
          </button>
          ${this.renderContent()}`;
  }
  /**
   * The name of the custom event fired before this accordion item is being
   * toggled upon a user gesture. Cancellation of this event stops the
   * user-initiated action of toggling this accordion item.
   */
  static get eventBeforeToggle() {
    return "adc-nav-item-beingtoggled";
  }
  /**
   * The name of the custom event fired after this accordion item is toggled
   * upon a user gesture.
   */
  static get eventToggle() {
    return "adc-nav-item-toggled";
  }
}
c.styles = [vt.styles || [], w(_)];
h([
  k({ selector: ".adc-link-item" })
], c.prototype, "_listItems", 2);
h([
  r({ type: Boolean, reflect: !0 })
], c.prototype, "disabled", 2);
h([
  r({ type: Boolean, reflect: !0 })
], c.prototype, "highlight", 2);
h([
  r({ type: Boolean, reflect: !0 })
], c.prototype, "open", 2);
h([
  r({ type: Boolean, reflect: !0, attribute: "toggle-off" })
], c.prototype, "toggleOff", 2);
h([
  r({
    type: Boolean,
    reflect: !0,
    attribute: "close-on-item-selected"
  })
], c.prototype, "closeOnItemSelected", 2);
h([
  r({
    type: String,
    reflect: !0,
    attribute: "tag-name"
  })
], c.prototype, "tagName", 2);
h([
  r({ type: String, reflect: !0, attribute: "a11y-tag-text" })
], c.prototype, "a11yTagText", 2);
h([
  r({ attribute: "label-text" })
], c.prototype, "labelText", 2);
h([
  r({ attribute: "a11y-label" })
], c.prototype, "a11yLabel", 2);
h([
  r({ attribute: "icon" })
], c.prototype, "icon", 2);
h([
  r({ type: Boolean, attribute: "icon-outlined" })
], c.prototype, "iconOutlined", 2);
h([
  r({ type: Number, reflect: !0, attribute: "badge-count" })
], c.prototype, "badgeCount", 2);
h([
  r({ type: String, reflect: !0, attribute: "a11y-badge-count-text" })
], c.prototype, "a11yBadgeCountText", 2);
try {
  customElements.define("adc-nav-item", c);
} catch {
}
function wt(a) {
  try {
    customElements.define(
      `${a}-nav-item`,
      class extends c {
        constructor() {
          super(a);
        }
      }
    );
  } catch {
  }
}
var yt = Object.defineProperty, xt = Object.getOwnPropertyDescriptor, C = (a, t, e, n) => {
  for (var i = n > 1 ? void 0 : n ? xt(t, e) : t, s = a.length - 1, l; s >= 0; s--)
    (l = a[s]) && (i = (n ? l(t, e, i) : l(i)) || i);
  return n && i && yt(t, e, i), i;
};
const kt = E(y);
class g extends v {
  constructor(t) {
    super(), this.disabled = !1, this.open = !1, this.icon = "", this.customElementString = t;
  }
  connectedCallback() {
    this.classList.add("adc-nav-link"), A(
      this.customElementString ? this.customElementString + "-nav-link" : "adc-nav-link"
    ), this.hasAttribute("role") || this.setAttribute("role", "listitem"), super.connectedCallback();
  }
  handleClick() {
    this.disabled || this.unnamedSlotEls[0].click();
  }
  createTagName(t) {
    return O(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    const { disabled: t, icon: e } = this;
    return u`<div
      tabindex="-1"
      ?disabled="${t}"
      part="title"
      @click="${this.handleClick}"
      class="adc-nav-bar__heading font-sans font-normal text-base leading-6"
      aria-controls="content"
      aria-expanded=${open}
    >
      <${this.createTagName(
      "-nav-link-icon"
    )} class="pr-2 text-blue-060" size="24" icon=${e}></${this.createTagName(
      "-nav-link-icon"
    )}>
      <slot
        class="font-sans font-normal text-xl leading-6 ${tt({
      "pointer-events-none": this.disabled
    })}"
      ></slot>
    </div>`;
  }
}
g.styles = [kt.styles || [], w(_)];
C([
  k()
], g.prototype, "unnamedSlotEls", 2);
C([
  r({ type: Boolean, reflect: !0 })
], g.prototype, "disabled", 2);
C([
  r({ type: Boolean, reflect: !0 })
], g.prototype, "open", 2);
C([
  r({ attribute: "icon" })
], g.prototype, "icon", 2);
try {
  customElements.define("adc-nav-link", g);
} catch {
}
function Et(a) {
  try {
    customElements.define(
      `${a}-nav-link`,
      class extends g {
        constructor() {
          super(a);
        }
      }
    );
  } catch {
  }
}
function At(a) {
  try {
    bt(a), wt(a), rt(a), Et(a);
  } catch {
  }
}
export {
  K as LinkItem,
  p as NavBar,
  c as NavItem,
  g as NavLink,
  M as getBadgeIconName,
  At as registerComponent,
  bt as registerLinkItem,
  rt as registerNavBar,
  wt as registerNavItem,
  Et as registerNavLink
};
